import { mainLayoutLocators } from '@locators/main-layout';
import SoftPhoneModule from '@modules/SoftPhoneModule';
import usePhoneState from '@modules/SoftPhoneModule/usePhoneState';

const CallStatePanel = () => {
  const phoneState = usePhoneState();

  return (
    <div>
      <pre>{JSON.stringify(phoneState, undefined, 2)}</pre>
      <button
        id={mainLayoutLocators.navBar.disconnectButton}
        onClick={() => SoftPhoneModule.callControl.disconnect()}
      >
        Disconnect
      </button>
    </div>
  );
};

export default CallStatePanel;
